import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router-dom";

import { AbsoluteRoute } from "../absoluteRoutes";

export const useLensManagementRoutes = (): {
    goToLensesList: () => void;
    goToLensPage: (lensId: string) => void;
    goToLensesListForLensFolder: (orgId: string, lensFolderId: string) => void;
} => {
    const navigate = useNavigate();

    const goToLensesList = useCallback(() => {
        navigate(AbsoluteRoute.LENSES);
    }, [navigate]);

    const goToLensesListForLensFolder = useCallback(
        (orgId: string, lensFolderId: string) => {
            const route = generatePath(AbsoluteRoute.ORG_LENS_FOLDER, { lensFolderId, orgId });
            navigate(route);
        },
        [navigate],
    );

    const goToLensPage = useCallback(
        (lensId: string) => {
            navigate(generatePath(AbsoluteRoute.LENS, { lensId }));
        },
        [navigate],
    );

    return {
        goToLensesList,
        goToLensPage,
        goToLensesListForLensFolder,
    };
};
